export const qualityType = {
  unknown: 'unknown',
  acquaintance: 'acquaintance',
  family: 'family',
  brother: 'brother',
  sister: 'sister',
  child: 'child',
  friend: 'friend',
  grandchild: 'grandchild',
  conjoint: 'conjoint',
} as const;

export type Quality = (typeof qualityType)[keyof typeof qualityType];
